import getSelection from './getSelection'

export default function getParentId(id, data) {
  const selection = getSelection(id, data)
  if (selection.class) {
    return selection.teacher
  } else if (selection.teacher) {
    return selection.school
  } else if (selection.school) {
    return selection.district
  } else {
    return ''
  }
}


// WEBPACK FOOTER //
// ./src/helpers/users/getParentId.js